import { createGlobalStyle } from 'styled-components';

const Reset = createGlobalStyle`
  ::selection {
    background-color: ${(props): string => props.theme.palette.primary.main};
    color: ${(props): string => props.theme.palette.primary.contrast};
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  *::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: ${(props): string => props.theme.scrollbar.track};
  }
  *::-webkit-scrollbar {
    width: 8px;
    border-radius: 8px;
    background-color: ${(props): string => props.theme.scrollbar.track};
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: ${(props): string => props.theme.scrollbar.thumb};
  }
  
  html {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }

  html, body, #__next {
    color: ${(props): string => props.theme.palette.text.primary};
    font-family: ${(props): string => props.theme.typography.fontFamily};
    font-size: ${(props): string | number => props.theme.typography.fontSize};
    font-weight: 400;
    height: 100%;
    margin: 0;
  }
  
  a,
  a:hover,
  a:visited {
    color: ${(props): string => props.theme.hyperlink.color.main};
    cursor: pointer;
    text-decoration: ${(props): string => props.theme.hyperlink.decoration};

    &[disabled] {
      color: ${(props): string => props.theme.hyperlink.color.light};
    }
  }
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
  
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }
`;

Reset.displayName = 'Reset';

export default Reset;
